import { useState } from "react";
import HeaderSection from "../../components/HeaderSection/HeaderSection";
import BottomSection from "../../components/BottomSection/BottomSection";
import { useTheme } from "../../context/ThemeContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDatabase } from "@fortawesome/free-solid-svg-icons";

const DataSizeConverter = () => {
  const [size, setSize] = useState("");
  const { darkMode } = useTheme();
  const [unit, setUnit] = useState("bytes");
  const [convertedSizes, setConvertedSizes] = useState({});

  const units = [
    "bits",
    "bytes",
    "kilobytes",
    "megabytes",
    "gigabytes",
    "terabytes",
  ];

  const convertSize = () => {
    if (!size || isNaN(size)) {
      setConvertedSizes({});
      return;
    }

    const bytes = parseFloat(size);
    let sizeInBytes;

    switch (unit) {
      case "bits":
        sizeInBytes = bytes / 8;
        break;
      case "bytes":
        sizeInBytes = bytes;
        break;
      case "kilobytes":
        sizeInBytes = bytes * 1024;
        break;
      case "megabytes":
        sizeInBytes = bytes * 1024 * 1024;
        break;
      case "gigabytes":
        sizeInBytes = bytes * 1024 * 1024 * 1024;
        break;
      case "terabytes":
        sizeInBytes = bytes * 1024 * 1024 * 1024 * 1024;
        break;
      default:
        sizeInBytes = bytes;
    }

    const results = {
      bits: sizeInBytes * 8,
      bytes: sizeInBytes,
      kilobytes: sizeInBytes / 1024,
      megabytes: sizeInBytes / (1024 * 1024),
      gigabytes: sizeInBytes / (1024 * 1024 * 1024),
      terabytes: sizeInBytes / (1024 * 1024 * 1024 * 1024),
    };

    setConvertedSizes(results);
  };

  const handleSizeChange = (e) => {
    const value = e.target.value.replace(/\s+/g, "");
    if (/^\d*\.?\d*$/.test(value) || value === "") {
      setSize(value);
    }
  };

  const handleUnitChange = (e) => {
    setUnit(e.target.value);
  };

  return (
    <>
      <HeaderSection toolId="dataSizeConverter" />
      <div className="max-w-4xl mx-auto p-4 lg:max-w-full lg:px-4 dark:text-white">
        <div className="bg-white rounded-xl dark:bg-gray-800 shadow-sm dark:shadow-gray-900/10 border border-gray-200 dark:border-gray-700 overflow-hidden">
          <div className="bg-gradient-to-r from-green-500 to-green-600 p-6 text-white">
            <h1 className="text-2xl font-bold mb-2 flex items-center">
              <FontAwesomeIcon icon={faDatabase} className="mr-3" />
              Data Size Converter
            </h1>
            <p className="opacity-90">
              Convert between different data size units (bits, bytes, KB, MB, GB, TB)
            </p>
          </div>

          <div className="p-6">
            <label
              className="block text-gray-700 dark:text-gray-200 mb-2"
              htmlFor="size"
            >
              Size
            </label>
            <div className="flex">
              <input
                type="text"
                id="size"
                value={size}
                onChange={handleSizeChange}
                className="w-3/4 px-3 py-2 border border-gray-300 rounded-l-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                placeholder="Enter size"
              />
              <select
                value={unit}
                onChange={handleUnitChange}
                className="w-1/4 px-3 py-2 border-t border-b border-r border-gray-300 rounded-r-md bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-white"
              >
                {units.map((u) => (
                  <option key={u} value={u}>
                    {u}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="px-6 pb-6">
            <button
              onClick={convertSize}
              className="w-full bg-green-500 hover:bg-green-600 text-white py-3 px-4 rounded-md transition-colors font-medium"
            >
              Convert
            </button>
          </div>

          {Object.keys(convertedSizes).length > 0 && (
            <div className="px-6 pb-6 space-y-3">
              <h3 className="text-lg font-semibold text-gray-700 dark:text-gray-200 mb-2">
                Conversion Results
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {units.map((u) => (
                  <div
                    key={u}
                    className="bg-gray-50 dark:bg-gray-700 p-3 rounded-lg"
                  >
                    <div className="flex justify-between items-center">
                      <span className="font-medium text-gray-700 dark:text-gray-200">
                        {u}:
                      </span>
                      <span className="font-mono text-gray-900 dark:text-gray-100">
                        {convertedSizes[u].toFixed(8).replace(/\.?0+$/, "")}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
      <BottomSection toolId="dataSizeConverter" />
    </>
  );
};

export default DataSizeConverter;